import type { FC } from 'react';
import { Container, NoDataContainer } from '@views/PageNotFound/PageNotFound.style';
import { Button, Typography } from '@components/atoms';
import { theme } from '@/theme.tsx';
import { PathNavigator } from '@utils/path-navigator.ts';

export const NotFound = () => {
  return (
    <NoDataContainer>
      <Typography
        component='h1'
        variant='h1'
        fontSize={theme.typography.fontSize * 4}
        marginBottom={2}
        align='center'
        color={theme.palette.common.black}
      >
        404
      </Typography>
      <Typography
        component='p'
        variant='h2'
        fontSize={theme.typography.fontSize * 2}
        marginBottom={2}
        align='center'
        color={theme.palette.common.black}
      >
        {"Something's missing."}
      </Typography>
      <Typography component='p' marginBottom={2} maxWidth={250} align='center'>
        This page is missing or you assembled the link incorrectly.
      </Typography>
    </NoDataContainer>
  );
};

export const NotFoundPage: FC = () => {
  return (
    <Container>
      <NotFound />
      <Button name='back-to-home' fullWidth={false} href={PathNavigator.home}>
        Back to home
      </Button>
    </Container>
  );
};
